module.exports = __webpack_public_path__ + "static/media/ConfirmacionLogo.3e12b3a3.png";